module.exports = __webpack_public_path__ + "img/chevron_down.eab24cb9.svg";